// tslint:disable:max-line-length
import * as React from 'react';

import { createIcon } from '../icon';

export const BankSberPure = createIcon(
  <svg xmlns="http://www.w3.org/2000/svg" width="82" height="79" viewBox="0 0 82 79">
    <g fill="#FFF" fillRule="evenodd" opacity=".2">
      <path d="M65.5 5.1L69 8.3 24.8 33.7 3.4 21.3l2-4 19.4 11.1L65.5 5.1zM56.6 0l4.7 2.4-36.5 21-17-9.7 2.9-3.5 14.1 8.1L56.6 0zm15.5 11.6l2.6 3.5-49.9 28.7L.7 30l1.1-4.4 23 13.2 47.3-27.2z" />
      <path d="M79.3 24.5c1.466 4.134 2.2 8.466 2.2 13 0 4.534-.734 8.934-2.2 13.2l-1 2.702a41.583 41.583 0 0 1-8.7 13c-3.8 3.732-8.132 6.6-13 8.6-5.132 2.2-10.432 3.3-15.9 3.3a39.536 39.536 0 0 1-15.9-3.3c-4.734-2-9.034-4.868-12.9-8.6-3.8-3.8-6.7-8.134-8.7-13C1.066 48.266 0 42.966 0 37.5v-2.7l24.8 14.1 52.3-30 2.2 5.6z" />
    </g>
  </svg>,
);

export const BankSberIcon: React.SFC<{ iconClassName?: string; style?: React.CSSProperties }> = props => (
  <BankSberPure className={props.iconClassName} style={props.style} />
);

BankSberIcon.displayName = 'BankSberIcon';
